import { render, staticRenderFns } from "./ProductPriceAndCart.vue?vue&type=template&id=4056d9bf&"
import script from "./ProductPriceAndCart.vue?vue&type=script&lang=js&"
export * from "./ProductPriceAndCart.vue?vue&type=script&lang=js&"
import style0 from "./ProductPriceAndCart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports